
const CodingList = () => {
    return (
        <tr className="evaluator-table-row">
            <td>Java</td>
            <td>3SU19SD060</td>
            <td>40</td>
            <td>5</td>
            <td>10-06-2022</td>
        </tr>

    )
}

export default CodingList;
